/* sb-dc-hideprod.js - take products with no designs out of the template
   picker. 2026-09-12.

   Reported (feedback item 10): choosing Kiss-Cut Stickers on the Design
   Templates page gives "No templates match this selection yet." and, unlike
   every other product, no "Create/Upload your Design" card either - so the
   customer is simply stuck.

   MEASURED (live): #sbdt-product carries 19 options, one of them "Kiss-Cut
   Stickers" (value 12), and the grid comes back empty for it.

   The store's call was to take it out for now rather than invent templates for
   it. This removes the option from the picker, and puts it back the moment
   designs exist: the list below is by NAME, and if the store tags even one
   design to that product the right move is to delete the entry here.

   Only the dropdown entry is touched. The product, its page, and its templates
   (if any are ever added) are untouched, and /pages/design-templates?for=... is
   left alone - a link someone already has still works.

   Nothing else on the page is changed, so if this file is removed the picker
   is exactly as it was.

   Diagnostics: window.__dcHideProd() */
(function () {
  'use strict';

  /* match on the visible label, lowercased, trimmed */
  var HIDE = [/^kiss-?cut/i];

  var info = { removed: [], passes: 0, why: '' };
  window.__dcHideProd = function () { return info; };

  function sweep() {
    info.passes++;
    var sel = document.getElementById('sbdt-product');
    if (!sel) return;
    var opts = Array.prototype.slice.call(sel.options);
    for (var i = 0; i < opts.length; i++) {
      var label = (opts[i].textContent || '').replace(/\s+/g, ' ').trim();
      var hit = false;
      for (var j = 0; j < HIDE.length; j++) if (HIDE[j].test(label)) hit = true;
      if (!hit) continue;
      if (opts[i].selected) sel.selectedIndex = 0;   // do not strand the page on it
      opts[i].parentNode.removeChild(opts[i]);
      if (info.removed.indexOf(label) < 0) info.removed.push(label);
    }
  }

  function start() {
    sweep();
    var t = setInterval(sweep, 800);               // the picker is rebuilt as data lands
    setTimeout(function () { clearInterval(t); }, 30000);
    new MutationObserver(sweep).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
